import React, { useEffect, useState } from "react";

const WalletStatsCard = ({ label, address, link, description }) => {
  const [totalValue, setTotalValue] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchValue = async () => {
      try {
        const res = await fetch(
          `https://public-api.birdeye.so/public/wallet/tokenlist?wallet=${address}`,
          {
            headers: {
              "x-chain": "solana",
            },
          }
        );
        const data = await res.json();
        const value = data?.data?.totalUsdValue ?? 0; // fallback to 0
        setTotalValue(value);
      } catch (error) {
        console.error("Birdeye fetch error:", error);
        setTotalValue(0); // still show $0.00 on failure
      } finally {
        setIsLoading(false);
      }
    };

    fetchValue();
  }, [address]);

  const formatDollars = (value) =>
    `$${parseFloat(value).toFixed(2)} USD`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white/5 p-6 rounded-xl shadow border border-white/10 hover:bg-white/10 transition text-white"
    >
      <h3 className="text-lg font-semibold mb-1">{label}</h3>
      <p className="text-xl font-bold underline text-[#f452c9]">
        {address.slice(0, 4)}...{address.slice(-3)}
      </p>
      <p className="mt-2 text-white/80 text-lg">
        {isLoading ? "Loading..." : formatDollars(totalValue)}
      </p>
      <p className="mt-3 text-white/70 text-sm leading-relaxed">
        {description}
      </p>
    </a>
  );
};

export default WalletStatsCard;
